import {useEffect} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import {eraseCookie, getCookie, hasCookieWithValue} from 'utils/cookie';
import {getOAuthState} from 'utils/oAuthState';
import {useHistory} from 'react-router-dom';

import {OAuthLogUser, useAppDispatch} from 'store';

export const OAuthPage = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();

    useEffect(() => {
        const cookieName = process.env.REACT_APP_OAUTH_TOKEN_COOKIE_NAME as string;
        const cookieToken = getCookie({name: cookieName});
        // ** One-time handoff cookie: consume it immediately regardless of outcome, don't rely on its expiry
        eraseCookie(cookieName);
        const state = localStorage.getItem(
            process.env.REACT_APP_OAUTH_STATE as string,
        );
        // ** The state coming back must be the one this browser started the login with: otherwise it's a forged login
        const oAuthState = getOAuthState();
        const stateMatches =
            !!oAuthState &&
            hasCookieWithValue({name: 'state', value: oAuthState});
        eraseCookie('state');

        if (cookieToken && state && stateMatches) {
            dispatch(
                OAuthLogUser({
                    token: cookieToken,
                    provider: state?.split('|')[0] as 'google' | 'facebook',
                    state: state?.split('|')[1] as string,
                }),
            );
        } else {
            // ** If no OAuth cookie token redirect back to login
            history.push('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            style={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <CircularProgress color="primary" style={{}} />
        </div>
    );
};
